import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { push } from "../../utils/navigation";
import { withRouter } from "../../utils/withRouter";
import {
  listClientLocations,
  saveUrgentDeliveryRequest,
} from "../../actions/homeActions";
import {allowUserWithRoles, BASE_URL, ROLE_OfficeUser, ROLE_SalesManager, ROLE_SuperUser} from "../../constants";
import { getErrorMessage, isCollectionExpectedVolumeMet, requestHasError } from "../../utils";
import UrgetnRequestUploadsAndNotes from "../Common/UrgentRequestUploadsAndNotes";
import UrgentDeliveries from "./UrgentDeliveries";
import UrgentDeliveryConfirmationModal from "../Common/UrgentDeliveryConfirmationModal";

const UrgentDeliveryRequest = ({ clientLocationsDelivery = [], dispatch, siteConfig, locationId, account, driverRuns }) => {
  const [notes, setNotes] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [conditionAgreed, setConditionAgreed] = useState(false);
  const [switchedDelivery, setSwitchedDelivery] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  

  useEffect(() => {
    setListLoading(true);
    dispatch(listClientLocations("Fresh Oil", locationId)).then(() => setListLoading(false));
  }, [locationId]);

  const handleFileDelete = ({ image, index }) => {
    let tempFileDelivery = [...files];
    tempFileDelivery.splice(index, 1);
    setFiles(tempFileDelivery);
  };

  const handleFileChange = (fileList) => {
    setFiles([...files, ...fileList]);
  };

  const handleNoteChange = (e) => {
    setNotes(e.currentTarget.value);
  };

  const handleSave = () => {
    if (!selectedDelivery) {
      return toastr.error("Please select a location.");
    }
    if (!conditionAgreed) {
      return toastr.error("Please accept terms and conditions.");
    }
    const isOfficeOrSuperUser = allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]);    
    
    if (!isOfficeOrSuperUser && _.isEmpty(files)) {
      return toastr.error("Please upload images.");
    }
    
    setSubmitLoading(true);
    let payLoad = {
      additionalInformation: notes,
      attachments: files,
      locationId: selectedDelivery,
    };
    dispatch(saveUrgentDeliveryRequest({ payLoad })).then((x) => {
      setSubmitLoading(false);
      if (!requestHasError({ x })) {
        toastr.success("Urgent delivery request created.");
        dispatch(push(`${BASE_URL}/client-requests`));
      }            
    });
  };

  const handleSelection = (id) => {
    if (selectedDelivery && id !== selectedDelivery) {
      setSwitchedDelivery(id);
      setViewModal(true);
    } else {
      setSelectedDelivery(id);
      if (
        isCollectionExpectedVolumeMet({
          list: clientLocationsDelivery,
          selectedCollection: id,
          autoApproveUrgentRunEstimate:
            siteConfig && siteConfig.autoApproveUrgentRunEstimate,
        })
      ) {
        setConditionAgreed(true);
      }
    }
  };

  const handleTermsAgreementChange = () => {
    setConditionAgreed(!conditionAgreed);
  };

  const handleModalClose = () => {
    setViewModal(false);
    setSwitchedDelivery(null);
  };

  const handleUpdateSelectedDelivery = () => {
    setSelectedDelivery(switchedDelivery);
    setSwitchedDelivery(null);
    setViewModal(false);
    setConditionAgreed(
      isCollectionExpectedVolumeMet({
        list: clientLocationsDelivery,
        selectedCollection: switchedDelivery,
        autoApproveUrgentRunEstimate:
          siteConfig && siteConfig.autoApproveUrgentRunEstimate,
      })
    );
    setFiles([]);
  };
  return (
    <React.Fragment>
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>Request Delivery</h4>
        </div>
      </div>
      <UrgentDeliveries
        list={clientLocationsDelivery}
        handleSelection={handleSelection}
        selectedDelivery={selectedDelivery}
        handleTermsAgreementChange={handleTermsAgreementChange}
        conditionAgreed={conditionAgreed}
        autoApproveUrgentRunEstimate={
          siteConfig && siteConfig.autoApproveUrgentRunEstimate
        }
        expectedVolumeMet={isCollectionExpectedVolumeMet({
          list: clientLocationsDelivery,
          selectedCollection: selectedDelivery,
          autoApproveUrgentRunEstimate:
            siteConfig && siteConfig.autoApproveUrgentRunEstimate,
        })}
        loading={listLoading}
        driverRuns={driverRuns}
      />
      {conditionAgreed && (
        <React.Fragment>
          <UrgetnRequestUploadsAndNotes
            handleFileChange={handleFileChange}
            handleFileDelete={handleFileDelete}
            handleNoteChange={handleNoteChange}
            files={files}
            notes={notes}
          />
          <div className="flex flex-row justify-content-end">
            <button
              className={`btn btn-success mobile-full-width mobile-screen-button mb-1 mr-2 float-right ${
                submitLoading ? "no-pointer-events" : ""
              }`}
              onClick={handleSave}
              disabled={submitLoading}
            >
              {submitLoading ? "Requesting" : "Confirm"}
            </button>
            <button
              className={`btn btn-default mobile-full-width mobile-screen-button mb-1 float-right ${
                submitLoading ? "no-pointer-events" : ""
              }`}
              onClick={() => {
                handleSelection(null);
              }}
              disabled={submitLoading}
            >
              Cancel
            </button>
          </div>
        </React.Fragment>
      )}
      <UrgentDeliveryConfirmationModal
        visible={viewModal}
        handleUpdateSelectedDelivery={handleUpdateSelectedDelivery}
        handleModalClose={handleModalClose}
      />
    </React.Fragment>
  );
};

function mapStateToProps(state, ownProps) {
  const locationId = parseInt(ownProps.routeParams.locationId);
  return {
    clientLocationsDelivery: state.home && state.home.clientLocationsDelivery,
    siteConfig: state.apiConfig,
    account: state.account,
    locationId: isNaN(locationId) ? null : locationId,
    driverRuns: state.driverRuns,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UrgentDeliveryRequest));
